import axios, { AxiosError } from 'axios'
import { toast } from 'react-toastify'

export const ShowAxiosError = (error: Error | AxiosError) =>
  axios.isAxiosError(error)
    ? toast.error(`${error.message}: ${error.response?.data}`)
    : toast.error(`Axios: Message: ${error.message}, Name: ${error.name}`)
